import React, { useState, useEffect, useRef } from "react";
import "../../App.css";
import "../../styles/components/mou-section.css";

// Events & Awards Page
const magazineItems = [
  { img: '/mag1.png', pdf: '/mag1.pdf', alt: 'Magazine 1' },
  { img: '/mag2.png', pdf: '/mag2.pdf', alt: 'Magazine 2' },
  { img: '/mag3.png', pdf: '/mag3.pdf', alt: 'Magazine 3' },
  { img: '/mag4.png', pdf: '/mag7.pdf', alt: 'Magazine 4' },
  { img: '/mag5.png', pdf: '/mag5.pdf', alt: 'Magazine 5' },
  { img: '/mag6.png', pdf: '/mag6.pdf', alt: 'Magazine 6' },
  { img: '/mag7.png', pdf: '/mag4.pdf', alt: 'Magazine 7' },
  { img: '/mag8.png', pdf: '/mag8.pdf', alt: 'Magazine 8' },
];

function EventsAwardsPage() {

  const [activeTab, setActiveTab] = useState('events');
  const [selectedMagazine, setSelectedMagazine] = useState(null);

  /* ---------- open / close modal ---------- */
  const openModal = (mag) => setSelectedMagazine(mag);
  const closeModal = () => setSelectedMagazine(null);

  /* ---------- magazines tab ---------- */
  const renderMagazinesContent = () => (
    <div className="tab-content__block">
      <h3 className="tab-content__title">Recognitions</h3>
      <p>
        Our journey and contributions to the industry have been chronicled in the pages of these distinguished magazines
      </p>
      <div className="magazines-grid">
        {magazineItems.map((m, i) => (
          <div key={i} className="magazine-card">
            <img
              src={m.img}
              alt={m.alt}
              className="magazine-card__image"
              onClick={() => openModal(m)}
            />
            {/* content wrapper keeps button at card bottom */}
            <div className="magazine-card__content">
              <button
                className="magazine-card__button"
                onClick={() => window.open(`/pdf-viewer.html?file=${encodeURIComponent(m.pdf)}`, '_blank')}
              >
                See More Info
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedMagazine && (
        <div className="magazine-modal" onClick={closeModal}>
          <div
            className="magazine-modal__content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="magazine-modal__close" onClick={closeModal}>
              &times;
            </button>

            <img
              src={selectedMagazine.img}
              alt={selectedMagazine.alt}
              className="magazine-modal__image"
            />

            <button
              className="magazine-modal__pdf-btn"
              onClick={() => window.open(`/pdf-viewer.html?file=${encodeURIComponent(selectedMagazine.pdf)}`, '_blank')}
            >
              Open PDF
            </button>
          </div>
        </div>
      )}
    </div>
  );

  /* ---------- strategic mou tab ---------- */
  const renderStrategicMouContent = () => (
    <div className="tab-content__block strategic-mou">
      <h3 className="tab-content__title">Strategic MoUs</h3>
      <p className="strategic-mou__intro">
        Strategic Partnerships play a crucial role in Geotech's operational model. By collaborating with Industry leaders such as ESRI India on geospatial software and entering MoU with Institutions like Anna University & Tamil Nadu Agricultural University, Geotech fosters knowledge exchange and drives innovation. These collaborations also contribute to talent development in the respective fields, as Geotech works with Institutions to help build the next generation of professionals.
      </p>
      
      <div className="strategic-mou__grid">
        <div className="mou-partner">
          <div className="mou-partner__logo">
            <img
              src="/Mou1.JPG"
              alt="ESRI India"
              onError={(e) => (e.target.src = '/placeholder-logo.png')}
            />
          </div>
        </div>

        <div className="mou-partner">
          <div className="mou-partner__logo">
            <img
              src="/Mou2.JPG"
              alt="Anna University"
              onError={(e) => (e.target.src = '/placeholder-logo.png')}
            />
          </div>
        </div>

        <div className="mou-partner">
          <div className="mou-partner__logo">
            <img
              src="/Mou3.jpg"
              alt="Tamil Nadu Agricultural University"
              onError={(e) => (e.target.src = '/placeholder-logo.png')}
            />
          </div>
        </div>


        <div className="mou-partner">
          <div className="mou-partner__logo">
            <img
              src="/Mou5.jpg"
              alt="Tamil Nadu Agricultural University"
              onError={(e) => (e.target.src = '/placeholder-logo.png')}
            />
          </div>
        </div>
      </div>
    </div>
  );

  /* ---------- awards tab ---------- */
  const awardItems = [
    { src: '/aw1.jpg', label: 'Esri India Partner of the year - 2019' },
    { src: '/aw2.jpg', label: 'Esri India partner of the year - 2021' },
    { src: '/aw3.jpg', label: 'Esri India partner of the year - 2023' },
    { src: '/aw4.png', label: 'Business Connect - Company of the year  2024' },
    { src: '/aw5.png', label: 'The InnerReview - Top 10 Inspiring IT Leaders' },
    { src: '/aw6.png', label: 'SiliconIndia - Top 10 GIS Service Provider 2024' },
    { src: '/aw7.png', label: 'Industry Outlook - Top 10 GIS Service Provider 2024' },
    { src: '/aw8.png', label: 'Industry Outlook - Top 10 GIS Service Provider 2023' },
    { src: '/aw9.png', label: 'Industrial Review - Best GIS Technology Partner 2024' },
    { src: '/aw10.png', label: 'Industrial Review - Excellence in providing Advanced GIS' },
  ];

  const renderAwardsContent = () => (
    <div className="tab-content__block">
      <h3 className="tab-content__title">Our Awards</h3>
      <p>
        Throughout our journey we have been recognised for our commitment to
        quality and innovation in the geospatial sector.
      </p>

      <div className="achievements-page-grid">
        {awardItems.map((award, i) => (
          <div key={i} className="achievement-card">
            <img
              src={award.src}
              alt={award.label}
              className="achievement-card__image"
              onError={(e) => (e.target.src = '/trophy-placeholder.png')}
            />
            <span className="achievement-card__label">
              {award.label}
            </span>
          </div>
        ))}
      </div>
    </div>

  );

  /* ---------- render page ---------- */
  return (
    <>

      {/* header */}
      <div className="events-awards-header">
        <div className="section__container">
          <h2 className="section__title">Accolades</h2>
          {/*<p className="section__intro">
            Stay updated on our latest events, milestones, and industry
            recognitions.
          </p>*/}
        </div>
      </div>
      {/* tabs */}
      <section className="section events-awards-page">
        <div className="section__container">
          <div className="tab-container">
            {/* main tabs */}
            <div className="tab-navigation">
              <button
                className={`tab-button ${activeTab === 'events' ? 'active' : ''}`}
                onClick={() => setActiveTab('events')}
              >
                Recognitions
              </button>

              <button
                className={`tab-button ${activeTab === 'awards' ? 'active' : ''}`}
                onClick={() => setActiveTab('awards')}
              >
                Awards
              </button>

              <button
                className={`tab-button ${activeTab === 'mou' ? 'active' : ''}`}
                onClick={() => setActiveTab('mou')}
              >
                Strategic MoU
              </button>
            </div>

            {/* tab content */}
            <div className="tab-content">
              {activeTab === 'events' && renderMagazinesContent()}
              {activeTab === 'awards' && renderAwardsContent()}
              {activeTab === 'mou' && renderStrategicMouContent()}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EventsAwardsPage;